import React from 'react';

import FailsafeImg from 'components/global/application/FailsafeImg';
import HtmlSummary from 'components/global/application/HtmlSummary';

import { imageUrlFromFid } from 'contexts/link_util';
import { Link } from 'react-router-dom';
import { InstrumentGroup, InstrumentGroupItem } from 'types/drupal/InstrumentGroupNode';
import { DetailInstrument } from 'types/drupal/InstrumentNode';

import { instrumentImageAltRef, instrumentImageUrlRef } from 'contexts/instrument';

import './InstrumentGroupDetail.sass';

export interface OwnProps {
    instrument: DetailInstrument;
    instrumentGroup: InstrumentGroup;
}

class InstrumentGroupDetail extends React.Component<OwnProps> {

    public render() {
        const instrumentGroup = this.props.instrumentGroup;
        const instrumentRefs = this.props.instrumentGroup.instrument_refs.filter((ref) => {
            return ref.instrument.nid !== this.props.instrument.nid;
        });
        const imgSrc = instrumentGroup.field_instrument_group_image ? imageUrlFromFid(instrumentGroup.field_instrument_group_image.fid, 'thumbnail') : '';
        const body = instrumentGroup.body ? instrumentGroup.body.value : '';

        const lines = instrumentRefs.length === 0 ? 6 : 4;

        return (
            <div className="preview">
                 <Link className="link" to={`/${instrumentGroup.alias}`}>
                    <h5>{instrumentGroup.title}</h5>
                        <div className="flex">
                            {this.mainImageSide(instrumentRefs, imgSrc)}
                            <div className="body">
                                <HtmlSummary htmlContent={body} lines={lines} />
                            </div>
                        </div>
                        <div className="flex">
                            {this.mainImageSub(instrumentRefs, imgSrc)}
                            <div className="flex flex-wrap sub-instruments">
                                {instrumentRefs.slice(0, 18).map((ref) => {
                                    return (<div key={ref.instrument.nid}>{this.subImage(ref)}</div>);
                                })}
                            </div>
                        </div>
                    <div className="action">Learn More</div>
                </Link>
            </div>
        );
    }

    public subImage(ref: InstrumentGroupItem) {
        const imgSrc = instrumentImageUrlRef(ref.instrument, 'tiny');
        const imgAlt = instrumentImageAltRef(ref.instrument);

        return (<FailsafeImg className="sub-thumbnail" alt={imgAlt} src={imgSrc} />);
    }

    public mainImageSub(instrumentRefs: InstrumentGroupItem[], imgSrc: string) {
        if (instrumentRefs.length === 0) {
            return;
        }
        if (imgSrc) {
            return (<div><FailsafeImg className="thumbnail" src={imgSrc} /></div>);
        }
    }

    public mainImageSide(instrumentRefs: InstrumentGroupItem[], imgSrc: string) {
        if (instrumentRefs.length > 0) {
            return;
        }
        if (imgSrc) {
            return (<div><FailsafeImg className="thumbnail" src={imgSrc} /></div>);
        }
    }
}

export default InstrumentGroupDetail;



// WEBPACK FOOTER //
// ./src/components/pages/inventory/detail/InstrumentGroupDetail.tsx